import React from "react";
import { observer } from "mobx-react";
import { Card, Paper } from "../../../../../common/components/libs";
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { OrganizationBranchClientDetails } from "../../../../../services/clients/models";
import styled from "styled-components";
import { useHistory } from "react-router";
import { convertDate } from "../../../../../common/libs";
import {Trans, useTranslation} from "react-i18next";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
`;

const ClientsList = ({ clients }: { clients: OrganizationBranchClientDetails[] }) => {
    const history = useHistory();


    const {i18n, t} = useTranslation(["general", "clients"]);
    const locale = i18n.language;

    return (
        <Card mb={3}>
            <Paper>
                <TableWrapper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                        width: 20
                                    }}
                                >
                                    id
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 50
                                    }}
                                >
                                    {t("clients:timeCreation")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 20
                                    }}
                                >
                                    {t("clients:ordersAmount")}
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: 50
                                    }}
                                >
                                    {t("general:actions")}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {clients.map((client) => {
                                return (
                                    <TableRow key={client.id}>
                                        <TableCell scope="row" style={{
                                            width: 20
                                        }}>
                                            {client.id}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 50
                                        }}>
                                            {convertDate(client.createdAt)}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 20
                                        }}>
                                            {client.totalOrders}
                                        </TableCell>
                                        <TableCell style={{
                                            width: 50
                                        }}>
                                            <Button
                                                color="primary"
                                                style={{ textAlign: "left" }}
                                                onClick={() => {
                                                    history.push(`/clients/orders/${client.id}`);
                                                }}
                                            >
                                                {t("clients:toOrders")}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            }
                        </TableBody>
                    </Table>
                </TableWrapper>
            </Paper>
        </Card>
    );
};

export default observer(ClientsList);
